import { ChiroUpAPI } from '@chiroup/client-core';
import { convertDayjsToUTC } from '@chiroup/core';

const appointmentService = () => {
  const create = async (body: any, timezone: string): Promise<any> => {
    return ChiroUpAPI.post('api', `/appointment`, {
      body: {
        ...body,
        startTime: convertDayjsToUTC({ datetime: body.startTime }),
        endTime: convertDayjsToUTC({ datetime: body.endTime }),
      },
    });
  };

  const createGuest = async (body: any): Promise<any> => {
    return ChiroUpAPI.post('api-noauth', `/appointment-guest`, {
      body,
    });
  };

  const update = async (id: string, body: any): Promise<any> => {
    return ChiroUpAPI.put('api', `/appointment/${id}`, {
      body,
    });
  };

  return {
    create,
    createGuest,
    update,
  };
};

export default appointmentService();
